import React from 'react';
import { useTranslation } from 'react-i18next';
import { Flex, Tag } from 'antd';

import Weight from 'components/controls/Weight';

interface FishboneLinksReadonlyProps {
	// selection.fishboneLinks (liens portant fishboneNodeId, nodeType, strength)
	links: any[];
	// Toutes les branches du projet, pour resoudre fishboneNodeId -> nom
	fishboneBranchs: any[];
	title?: string;
}

// Affichage inverse (lecture seule) des arêtes/sous-arêtes liées à un objet
// (risk/enjeu/indicateur/stakeholder). L'edition se fait cote fishbone.
export const FishboneLinksReadonly = (props: FishboneLinksReadonlyProps) => {
	const { t } = useTranslation();
	const links = props.links || [];

	// Index id -> { name, type } sur branches + sous-aretes
	const nodeIndex: Record<string, { name: string; type: string }> = {};
	(props.fishboneBranchs || []).forEach((b: any) => {
		if (b?.id) nodeIndex[b.id] = { name: b.name, type: 'branch' };
		(b?.items || []).forEach((i: any) => {
			if (i?.id) nodeIndex[i.id] = { name: i.name, type: 'item' };
		});
	});

	if (!links.length) return null;

	return (
		<Flex vertical className="mt-3">
			<div className="text-left mb-05">
				<strong>
					{props.title || t('pages.fishbone.title') || 'Strategic plan'}
				</strong>
			</div>
			<div className="text-left">
				{links.map((l: any) => {
					const node = nodeIndex[l.fishboneNodeId];
					const label = node?.name || l.fishboneNodeId;
					const kindLabel =
						(l.nodeType || node?.type) === 'branch'
							? t('models.fishbone_branch.name')
							: t('models.fishbone_item.name');
					return (
						<Tag key={l.id} className="tag" title={`${kindLabel} — ${label}`}>
							<span className="tag__label">{label}</span>
							{l.strength ? (
								<Weight onClick={() => {}}>{l.strength}</Weight>
							) : null}
						</Tag>
					);
				})}
			</div>
		</Flex>
	);
};

export default FishboneLinksReadonly;
